
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Input,
  Select,
  Button,
  Tooltip,
  Pagination
} from 'antd';
import {
  getTaskData,
  addSoftData,
  getUpdatedTaskDetails,
  printAddressLabel
} from 'src/api/SoftDataAdditionModalApis';
import { PrinterOutlined, SyncOutlined } from '@ant-design/icons';
import { SuccessIcon } from 'src/components/common/icons/opsDashboard/SuccessIcon';
import { PendingIcon } from 'src/components/common/icons/opsDashboard/PendingIcon';
import { ErrorIcon } from 'src/components/common/icons/opsDashboard/ErrorIcon';
import { ErrorIcon2 } from 'src/components/common/icons/opsDashboard/ErrorIcon2';
import { ScannerIcon } from 'src/components/common/icons/opsDashboard/ScannerIcon';

const { Option } = Select;

const styles = {
  field: {
    width: '160px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
  },
  field2: {
    width: '250px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    fontSize: '14px',
    fontWeight: 'normal',
    marginRight: '7px',
  },
  body: {
    padding: '16px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    height: '90vh',
  },
  card: {
    margin: 0,
    padding: '12px',
    backgroundColor: '#ffffff',
    border: '1px solid #D9D9D9',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    overflowX: 'auto',
  },
  infoCard: {
    margin: 0,
    padding: '12px',
    backgroundColor: '#ffffff',
    border: '1px solid #D9D9D9',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'stretch',
    gap: '10px',
    overflowX: 'auto',
    flexWrap: 'nowrap',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '180px',
    maxWidth: '300px',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    textAlign: 'left',
    gap: '8px',
  },
  hint: {
    fontSize: '10px',
    color: '#595959',
    fontWeight: 400,
    lineHeight: '1.5',
    textAlign: 'left',
  },
  value: {
    fontSize: '13px',
    color: '#262626',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    textAlign: 'left',
  },
  addButton: {
    marginLeft: 'auto',
    marginBottom: 'auto',
    height: '40px',
    fontSize: '16px',
    padding: '0 20px'
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '8px'
  },
  messageModalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '24px'
  },
  messageModalIcon: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '16px'
  },
  messageModalText: {
    textAlign: 'center',
    fontSize: '16px',
    color: '#262626',
    marginBottom: '8px'
  },
  detailsContainer: {
    margin: 0,
    backgroundColor: '#ffffff',
    border: '1px solid #D9D9D9',
    borderRadius: '6px',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px'
  },
  detailsInner: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    borderBottom: '1px solid #f0f0f0',
    paddingBottom: '8px',
    marginBottom: '8px',
    justifyContent: 'center'
  },
  headerCell: {
    fontWeight: 'bold',
    fontSize: '12px',
    paddingRight: '8px',
    textAlign: 'center'
  },
  headerCellCustomer: {
    width: '30%',
    fontWeight: 'bold',
    fontSize: '12px',
    paddingRight: '8px',
    textAlign: 'center'
  },
  headerCellConsignment: {
    width: '30%',
    fontWeight: 'bold',
    fontSize: '12px',
    paddingRight: '8px',
    textAlign: 'center'
  },
  headerCellStatus: {
    width: '25%',
    fontWeight: 'bold',
    fontSize: '12px',
    paddingRight: '8px',
    textAlign: 'center'
  },
  headerCellAction: {
    width: '15%',
    fontWeight: 'bold',
    fontSize: '12px',
    position: 'relative',
    textAlign: 'center'
  },
  actionHeaderContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  refreshButton: {
    position: 'absolute',
    right: 0
  },
  dataRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: '8px 0',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dataCell: {
    fontSize: '13px',
    paddingRight: '8px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dataCellCustomer: {
    width: '30%',
    fontSize: '13px',
    paddingRight: '8px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dataCellConsignment: {
    width: '30%',
    fontSize: '13px',
    paddingRight: '8px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dataCellStatus: {
    width: '25%',
    fontSize: '13px',
    paddingRight: '8px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dataCellAction: {
    width: '15%',
    fontSize: '13px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  tooltipIcon: {
    cursor: 'pointer'
  }
};

// Pretty name mapping
const prettyNameMap = {
  taskID: 'Task ID',
  customerId: 'Customer ID',
  customer_name: 'Customer Name',
  task_reference_number: 'Pickup Number',
  sticker_number: 'Sticker Number',
  created_at: 'Pickup Creation Date',
  completion_time: 'Pickup Completion Date',
  load_type: 'Load Type',
  given_items_count: 'Picked Count',
  consignment_count: 'CN with Soft Data',
  origin_address: 'Origin Address',
  destination_address: 'Destination Address'
};

const MessageModal = ({ isVisible, message, type = 'error', onClose }) => (
  <Modal
    visible={isVisible}
    onCancel={onClose}
    footer={null}
    centered
    width={400}
    closable={true}
  >
    <div style={styles.messageModalContainer}>
      <div style={{
        ...styles.messageModalIcon,
        background: type === 'success' ? '#4CAF50' : '#E31837'
      }}>
        <span>
          {type === 'success' ? <SuccessIcon /> : <ErrorIcon />}
        </span>
      </div>
      <div style={styles.messageModalText}>
        {message}
      </div>
    </div>
  </Modal>
);

const SoftDataAdditionModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    searchType: 'stickerNumber',
    searchValue: '',
    customerRef: '',
    customerID: '',
    taskID: '',
  });

  const [showCards, setShowCards] = useState(false);
  const [showDetailsCard, setShowDetailsCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [cnDetails, setCnDetails] = useState([]);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalConfig, setMessageModalConfig] = useState({
    message: '',
    type: 'error',
  });

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalConsignments, setTotalConsignments] = useState(0);
  const [lastRowIdNext, setLastRowIdNext] = useState(null);
  const [lastRowIdPrev, setLastRowIdPrev] = useState(null);
  const [nextOrPrev, setNextOrPrev] = useState('next');

  const handleApiError = (error) => {
    setMessageModalConfig({
      message: error.message || 'An unexpected error occurred.',
      type: 'error',
    });
    setShowMessageModal(true);
  };


  const handlePrintLabel = async (referenceNumber) => {
    try {
      const body = {
        referenceNumberClientIdMapping: [{
          referenceNumber: referenceNumber,
          clientId: formData.customerID
        }],
        small: true
      };

      const response = await printAddressLabel(body);
      const { isSuccess, errorMessage, data } = response;

      if (!isSuccess) {
        setMessageModalConfig({
          message: errorMessage || 'Error printing label',
          type: 'error',
        });
        setShowMessageModal(true);
        return;
      }

      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.download = `Address_Label_${referenceNumber}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      setMessageModalConfig({
        message: error.message || 'Failed to print label',
        type: 'error',
      });
      setShowMessageModal(true);
    }
  };

  const handleRefresh = async () => {
    try {
      setIsRefreshing(true);
      
      setTimeout(async () => {
        await updateTaskDetails(true);
      }, 60000);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsRefreshing(false);
    }
  };

  const updateTaskDetails = async (isRefreshingOperation = false) => {
    try {
      const params = {
        taskID: formData.taskID.toString(),
        pageSize,
        sortBy: 'id',
        nextOrPrev
      };

      if (nextOrPrev === 'next' && lastRowIdNext && !isRefreshingOperation) {
        params.lastRowIdNext = lastRowIdNext;
      } else if (nextOrPrev === 'prev' && lastRowIdPrev && !isRefreshingOperation) {
        params.lastRowIdPrev = lastRowIdPrev;
      }

      const response = await getUpdatedTaskDetails(params);
      const { isSuccess, data } = response;

      if (isSuccess && data.success) {
        // Update task table data
        setTableData(prevTableData =>
          prevTableData.map(item => ({
            ...item,
            consignment_count: data.consignment_count
          }))
        );

        // Update consignment details
        if (data.cnDetails && Array.isArray(data.cnDetails)) {
          setCnDetails(data.cnDetails);
          setShowDetailsCard(true);
          
          // Update pagination metadata
          setTotalConsignments(data.totalConsignments || 0);
          setLastRowIdNext(data.lastRowIdNext);
          setLastRowIdPrev(data.lastRowIdPrev);
        }
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handlePageChange = (page) => {
    if (page > currentPage) {
      setNextOrPrev('next');
    } else {
      setNextOrPrev('prev');
    }
    setCurrentPage(page);
  };

  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
    setNextOrPrev('next');
    setLastRowIdNext(null);
    setLastRowIdPrev(null);
  };

  useEffect(() => {
    if (formData.taskID && showDetailsCard) {
      setTimeout(async () => {
        await updateTaskDetails();
      }, 60000);
    }
  }, [currentPage, pageSize, nextOrPrev]);

  const fetchPickupData = async (searchValue) => {
    try {
      setIsLoading(true);
      const type = formData.searchType === 'pickupNumber' ? 'pickupNumber' : 'stickerNumber';
      const response = await getTaskData(searchValue.toString(), type);
      const { isSuccess, data, errorMessage } = response;

      if (isSuccess) {
        const taskID = data.taskID;
        const customerID = data.customerId;
        const { taskID: _, customerId: _, ...fields } = data;
        setTableData([fields]);
        setFormData(prev => ({
          ...prev,
          taskID: taskID,
          customerID: customerID,
        }));
        setShowCards(true);
      } else {
        handleApiError({ message: errorMessage || 'Error fetching task data.' });
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAdd = async (customerRef, searchValue) => {
    try {
      const type = formData.searchType === 'pickupNumber' ? 'pickupNumber' : 'stickerNumber';
      const response = await addSoftData({
        crn: customerRef.toString(),
        number: searchValue.toString(),
        type: type
      });
      const { isSuccess, data, errorMessage } = response;

      if (isSuccess) {
        if (!data.success) {
          setMessageModalConfig({
            message: data.message,
            type: 'error',
          });
          setShowMessageModal(true);
          return;
        }

        if (data.success) {
          await updateTaskDetails(true);
        }

      } else {
        handleApiError({ message: errorMessage || 'Error fetching details.' });
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleKeyPress = (e, type) => {
    if (e.key === 'Enter') {
      if (type === 'searchValue') {
        fetchPickupData(formData.searchValue);
      } else if (type === 'customerRef') {
        handleAdd(formData.customerRef, formData.searchValue);
      }
    }
  };

  const handleInputChange = (value, field) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <>
      <Modal
        title="Add New Softdata"
        visible={isOpen}
        onCancel={onClose}
        footer={null}
        bodyStyle={styles.body}
        centered={true}
        maskClosable={false}
        width='95%'
      >
        <div style={styles.card}>
          <Select
            value={formData.searchType}
            onChange={(value) => handleInputChange(value, 'searchType')}
            style={styles.field}
          >
            <Option value="stickerNumber">Sticker Number</Option>
            <Option value="pickupNumber">Pickup Number</Option>
          </Select>
          <Input
            value={formData.searchValue}
            onChange={(e) => handleInputChange(e.target.value, 'searchValue')}
            onKeyDown={(e) => handleKeyPress(e, 'searchValue')}
            placeholder="Search"
            style={styles.field}
            loading={isLoading}
          />
        </div>

        {showCards && (
          <>
            {tableData.map((item) => (
              <div key={item.key} style={styles.infoCard}>
                {Object.entries(item).map(([key, value]) => (
                  <div key={key} style={styles.infoItem}>
                    <div style={styles.hint}>{prettyNameMap[key] || key}</div>
                    <div style={styles.value}>{value || 'Not Available'}</div>
                  </div>
                ))}
              </div>
            ))}

            <div style={styles.card}>
              <span style={styles.text}>Customer Reference No.</span>
              <Input
                placeholder="Search"
                value={formData.customerRef}
                onChange={(e) => handleInputChange(e.target.value, 'customerRef')}
                onKeyDown={(e) => handleKeyPress(e, 'customerRef')}
                style={styles.field}
              />
              <ScannerIcon />
            </div>

            {showDetailsCard && cnDetails.length > 0 && (
              <>
                <div style={styles.detailsContainer}>
                  <div style={styles.detailsInner}>
                    {/* Header row */}
                    <div style={styles.headerRow}>
                      <div style={styles.headerCellCustomer}>Customer Reference Number</div>
                      <div style={styles.headerCellConsignment}>Consignment Reference Number</div>
                      <div style={styles.headerCellStatus}>Booking Sync Status</div>
                      <div style={styles.headerCellAction}>
                        <div style={styles.actionHeaderContent}>
                          <span>Action</span>
                          <Tooltip title="Refresh">
                            <Button
                              icon={<SyncOutlined />}
                              size="small"
                              onClick={handleRefresh}
                              loading={isRefreshing}
                              style={styles.refreshButton}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>

                    {/* Data rows */}
                    {cnDetails.map((item, index) => (
                      <div key={index} style={{
                        ...styles.dataRow,
                        borderBottom: index < cnDetails.length - 1 ? '1px solid #f0f0f0' : 'none'
                      }}>
                        <div style={styles.dataCellCustomer}>
                          {item.customer_reference_number || 'Not Available'}
                        </div>
                        <div style={styles.dataCellConsignment}>
                          {item.reference_number || 'Not Available'}
                        </div>
                        <div style={styles.dataCellStatus}>
                          {item.booking_status === 'synced' ? (
                            <SuccessIcon />
                          ) : item.booking_status === 'not_synced' ? (
                            <Tooltip
                              title={item.booking_error_message || 'Booking Not Synced'}
                              placement="top"
                            >
                              <div style={styles.tooltipIcon}>
                                <ErrorIcon2 />
                              </div>
                            </Tooltip>
                          ) : (
                            <Tooltip
                              title="Pending"
                              placement="top"
                            >
                              <div style={styles.tooltipIcon}>
                                <PendingIcon />
                              </div>
                            </Tooltip>
                          )}
                        </div>
                        <div style={styles.dataCellAction}>
                          <Button
                            icon={<PrinterOutlined />}
                            onClick={() => handlePrintLabel(item.reference_number)}
                            disabled={!item.reference_number}
                            size="small"
                          >
                            Print Label
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Pagination */}
                <div style={styles.paginationContainer}>
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={totalConsignments}
                    onChange={handlePageChange}
                    onShowSizeChange={handlePageSizeChange}
                    showSizeChanger
                    showQuickJumper
                    showTotal={(total) => `Total ${total} consignments`}
                  />
                </div>
              </>
            )}
          </>
        )}
      </Modal>
      <MessageModal
        isVisible={showMessageModal}
        message={messageModalConfig.message}
        type={messageModalConfig.type}
        onClose={() => setShowMessageModal(false)}
      />
    </>
  );
};

export default SoftDataAdditionModal;
